// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__WluFs","indicator":"styles_indicator__uNSwr","indicatorActive":"styles_indicatorActive__g7zr0"};